<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'reset_log_pointer_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'drivers.name' | translate }}</span>
      <input type="text" [value]="name" disabled />
    </label>
    <label>
      <span>{{ 'drivers.last_name' | translate }}</span>
      <input type="text" [value]="lastName" disabled />
    </label>
    <label>
      <span>{{ 'reset_log_pointer_dialog.days_ago' | translate }}</span>
      <input type="number" min="0" step="1" [(ngModel)]="daysAgoInput" [placeholder]="'reset_log_pointer_dialog.placeholder_days' | translate" />
    </label>
    <div class="error" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'reset_log_pointer_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting">{{ 'reset_log_pointer_dialog.continue' | translate }}</button>
  </div>
</div>


